import {Link, useNavigate} from "react-router-dom";
import React, {useRef, useState} from "react";
import {useOnClickOutside} from "../../utils/useHook/useHook";
import {useGlobalContext, useSSEContext, useStaffContext, useUserContext} from "../../hooks/globalContext";
import {addNotification, addNotificationWithButton} from "../../utils/toast/toast";
import moment from "moment/moment";
import {ReactComponent as BurgerSVG} from '../../resourse/img/general/ic-burger.svg';
import {useActions} from "../../migration/shared/lib/hooks/useActions";
import {RouteNames} from "../../migration/pages";
import {ModalReport} from "../modal/modalReport";
// import {ModalPublishSuccess} from "../modal/modalPublishSuccess";


interface HeaderUserProps {
    setShowSiteBar: React.Dispatch<React.SetStateAction<boolean>>
    menuIsEmpty: boolean
}

export function HeaderUser({setShowSiteBar, menuIsEmpty}: HeaderUserProps) {
    const {setAuth, setInitialLocation} = useActions();
    const {i18n, api} = useGlobalContext()
    const {user, currentMenuId, setUser} = useUserContext()
    const {removeOrg} = useStaffContext()

    const {menuPublishSSE, setMenuPublishSSE} = useSSEContext()
    let curMenu = menuPublishSSE[currentMenuId]
    const [publishLoading, setPublishLoading] = useState<boolean>(false)
    const [publishModalOpen, setPublishModalOpen] = useState<boolean>(false)

    function onPublish(e: any) {
        e.preventDefault()
        if (currentMenuId && user?.org) {
            setPublishLoading(true)
            api.publishMenu({setLoading: setPublishLoading}, currentMenuId, user?.org.id).then((res) => {
                if (res.success) {
                    setMenuPublishSSE({
                        ...menuPublishSSE, [currentMenuId]: {
                            isDirty: false,
                            lastPublishedAt: new Date().toISOString(),
                            menuId: currentMenuId,
                        }
                    })
                    setPublishModalOpen(true)
                }
            }).finally(() => setPublishLoading(false))
        }
    }

    function downloadQr() {
        api.downloadQrCode({setLoading: () => {}}, currentMenuId)
    }

    function downloadMenu() {
        let subdomain = user?.org?.subdomain
        let menuLink = user?.org?.menus.menus?.find((v) => v.id === currentMenuId)?.link
        let url = process.env.REACT_APP_API_URL
        if (!user?.org || !subdomain || !menuLink || !url) return
        window.open(`${url.replace("api", subdomain)}/print/${menuLink}?preview=true`)
    }

    let [showUserMenu, setShowUserMenu] = useState<boolean>(false)

    const [logOutLoading, setLogOutLoading] = useState(false)

    const userRef = useRef(null)
    const navigate = useNavigate()


    useOnClickOutside(userRef, () => setShowUserMenu(false), "mouseup")

    function onLogout(e: any) {
        e.preventDefault()
        if (user?.isStaff) {
            removeOrg(user?.org?.id || "")
            navigate(RouteNames.STAFF_CLIENTS)
        } else {
            api.logout({setLoading: setLogOutLoading}).then((res) => {
                if (res.success) {
                    setUser(null)
                    setAuth(false)
                    localStorage.clear()
                    setInitialLocation(RouteNames.LOGIN)
                    navigate(RouteNames.LOGIN)
                }
            })
        }
    }

    return (
        <header className="header">
            <div className="header__container">
                <button type="button" onClick={() => setShowSiteBar(true)}
                        className="burger js-menu-trigger">
                    <BurgerSVG/>
                    <span id="unread-mark" className="text-danger" style={{display: "none"}}>●</span>
                </button>
                {user?.isStaff || false ?
                    null :
                    <div className="header__shop-name">
                        {user?.org?.name}
                    </div>
                }
                {menuIsEmpty ?
                    null
                    :
                    <>
                        {/*Qr ---------------------------------------------*/}
                        <DownloadButton/>
                        <ChangeMenuComponent/>
                    </>
                }
                {
                    user?.isStaff || false ?
                        <ChangeOrgComponent/>
                        : null
                }

                <div ref={userRef} className={showUserMenu ? "header__user dropdown show" : "header__user dropdown"}
                     style={{display: "flex"}}
                >
                    <div style={{marginRight: "20px", display: menuIsEmpty ? "none" : "block"}}>
                        {curMenu?.lastPublishedAt ?
                            <span className="mr-2">{i18n.last_publish_date()}:
                                {moment().to(new Date(curMenu.lastPublishedAt))}
                            </span>
                            : null}

                        <button type="button" className={curMenu?.isDirty ? "button -yellow" : "button -bordered_blue"}
                                style={{padding: "6px"}}
                                onClick={onPublish}
                        >
                            {i18n.publish_price_list()}
                        </button>
                    </div>

                    <a className="header__user-toggle" href={"#"} onClick={(e) => {
                        e.preventDefault()
                        setShowUserMenu((prev) => !prev)
                    }} id="userDropdown"
                       data-toggle="dropdown" aria-haspopup={showUserMenu} aria-expanded={showUserMenu}>
                        <div className="header__user-icon">

                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                 viewBox="0 0 50 50" enableBackground={"new 0 0 50 50"} xmlSpace="preserve">
                                <path d="M5,32v17h30.343l2.167-1.686C42.27,43.612,45,38.03,45,32v-0.649l-8.841-3.931c-1.59-4.225-5.229-7.262-9.55-8.147
                                     C29.257,17.472,31,14.436,31,11c0-5.514-4.486-10-10-10S11,5.486,11,11c0,3.431,1.739,6.464,4.38,8.265C9.464,20.481,5,25.729,5,32
                                     z M42.988,32.645c-0.187,5.16-2.607,9.903-6.707,13.092L35,46.733l-1.281-0.997c-4.1-3.188-6.521-7.932-6.707-13.092l7.99-3.55
                                     L42.988,32.645z M13,11c0-4.411,3.589-8,8-8s8,3.589,8,8s-3.589,8-8,8S13,15.411,13,11z M18,21h6c4.312,0,8.173,2.517,9.961,6.367
                                     L25,31.351V32c0,5.865,2.589,11.3,7.109,15H7V32C7,25.935,11.935,21,18,21z"
                                      fill="#646D7C">
                                </path>
                                <polygon
                                    points="36,33 34,33 34,36 31,36 31,38 34,38 34,41 36,41 36,38 39,38 39,36 36,36 	">
                                </polygon>
                            </svg>

                        </div>
                        <div className="header__user-info">
                            <div className="header__user-name">
                                {user?.user ? user?.user.username : ""}
                            </div>
                        </div>
                    </a>

                    <div ref={userRef}
                         className={showUserMenu ? "dropdown-menu dropdown-menu-right show" : "dropdown-menu dropdown-menu-right"}
                         tabIndex={0}>
                        <Link to="/account/" onClick={() => setShowUserMenu(false)}
                              className="header__user-sublink">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M17.9523 8.21178C17.6542 8.15346 17.4113 7.93742 17.3187 7.64803C17.1918 7.25174 17.0328 6.86628 16.8436 6.49625C16.7056 6.22632 16.725 5.9027 16.8944 5.65123L17.585 4.62592L15.3685 2.40485L14.3387 3.10108C14.0877 3.27083 13.7642 3.2909 13.4941 3.15348C13.1369 2.97179 12.7655 2.81808 12.384 2.69442C12.0952 2.6008 11.8802 2.35751 11.8227 2.05938L11.5871 0.836475L10 0.833333H8.43167L8.19347 2.05577C8.1354 2.35372 7.91991 2.59654 7.63095 2.68958C7.24423 2.81412 6.86783 2.96934 6.50594 3.15347C6.2358 3.29091 5.91233 3.27084 5.66126 3.10106L4.63177 2.40491L2.41508 4.62585L3.10581 5.65142C3.27516 5.90287 3.2946 6.22646 3.15657 6.49637C2.96987 6.86144 2.81251 7.2419 2.68652 7.63298C2.59334 7.92227 2.35006 8.13787 2.05167 8.19563L0.836742 8.43075L0.833542 11.5507L2.04778 11.7882C2.34609 11.8466 2.58897 12.0627 2.68156 12.3522C2.8082 12.7482 2.96723 13.1337 3.15649 13.5037C3.29461 13.7736 3.27519 14.0972 3.10578 14.3488L2.41509 15.3742L4.63177 17.5951L5.66126 16.8989C5.91232 16.7292 6.23577 16.7091 6.50591 16.8465C6.863 17.0282 7.23458 17.1819 7.61612 17.3056C7.90493 17.3992 8.11998 17.6425 8.17742 17.9406L8.413 19.1633L11.5685 19.1665L11.8065 17.9443C11.8646 17.6463 12.0801 17.4035 12.3691 17.3104C12.7557 17.1859 13.1321 17.0307 13.4938 16.8465C13.764 16.7089 14.0877 16.729 14.3388 16.8988L15.3683 17.5952L17.5849 15.3742L16.8942 14.3486C16.7248 14.0971 16.7054 13.7733 16.8436 13.5034C17.0303 13.1385 17.1877 12.7581 17.3137 12.367C17.4068 12.0777 17.6501 11.8622 17.9485 11.8044L19.1634 11.5692L19.1665 8.44925L17.9523 8.21178ZM15.0492 18.3853L13.8719 17.5891C13.4707 17.7934 13.0533 17.9656 12.6245 18.1037L12.3481 19.5227C12.2943 19.7995 12.0438 20 11.7533 20L8.22644 19.9965C7.93556 19.9962 7.68609 19.7952 7.6327 19.518L7.35914 18.0983C6.93597 17.9611 6.52398 17.7907 6.12806 17.5892L4.95082 18.3853C4.70735 18.5499 4.37646 18.5192 4.16999 18.3121L1.67616 15.8134C1.48008 15.6169 1.45032 15.3149 1.6045 15.0859L2.41462 13.8833C2.20469 13.4729 2.0283 13.0453 1.88782 12.6061L0.485067 12.3317C0.202689 12.2765 -0.000314247 12.0358 3.65177e-07 11.7568L0.00362298 8.22312C0.00378047 7.94387 0.207413 7.70371 0.489949 7.64908L1.89333 7.37747C2.03303 6.94382 2.20753 6.52191 2.41462 6.11694L1.6045 4.91409C1.45032 4.68506 1.48008 4.38324 1.67616 4.18655L4.16999 1.68792C4.37646 1.48102 4.70719 1.44989 4.95082 1.61468L6.12806 2.41073C6.52933 2.20657 6.94668 2.03446 7.37552 1.89636L7.65208 0.477295C7.70593 0.200501 7.95556 0 8.24628 0H10L11.7736 0.00350952C12.0646 0.00381469 12.3141 0.204773 12.3674 0.482025L12.641 1.9017C13.0642 2.03888 13.476 2.20932 13.8719 2.41073L15.0493 1.61468C15.2928 1.44989 15.6238 1.48102 15.8302 1.68778L18.3238 4.18655C18.5201 4.38308 18.5498 4.68506 18.3957 4.91409L17.5855 6.11679C17.7955 6.52725 17.9717 6.95465 18.1123 7.39395L19.5149 7.66831C19.7975 7.72354 20.0003 7.96417 20 8.24326L19.9965 11.7769C19.9963 12.0561 19.7927 12.2963 19.5101 12.3509L18.1068 12.6225C17.9672 13.0562 17.7927 13.4781 17.5854 13.8831L18.3955 15.0859C18.5498 15.3149 18.5201 15.6168 18.3238 15.8134L15.8302 18.3121C15.6237 18.519 15.2928 18.5499 15.0492 18.3853Z"
                                      fill="#8392A5"></path>
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M10.0001 6.66683C8.16277 6.66683 6.66671 8.16288 6.66671 10.0002C6.66671 11.8374 8.16277 13.3335 10.0001 13.3335C11.8373 13.3335 13.3334 11.8375 13.3334 10.0002C13.3334 8.16286 11.8373 6.66683 10.0001 6.66683ZM5.83337 10.0002C5.83337 7.70263 7.70255 5.8335 10.0001 5.8335C12.2975 5.8335 14.1667 7.70263 14.1667 10.0002C14.1667 12.2977 12.2975 14.1668 10.0001 14.1668C7.70255 14.1668 5.83337 12.2977 5.83337 10.0002Z"
                                      fill="#8392A5"></path>
                            </svg>
                            {i18n.account()}
                        </Link>
                        <Link to="/organization-settings" onClick={() => setShowUserMenu(false)}
                              className="header__user-sublink">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M17.9523 8.21178C17.6542 8.15346 17.4113 7.93742 17.3187 7.64803C17.1918 7.25174 17.0328 6.86628 16.8436 6.49625C16.7056 6.22632 16.725 5.9027 16.8944 5.65123L17.585 4.62592L15.3685 2.40485L14.3387 3.10108C14.0877 3.27083 13.7642 3.2909 13.4941 3.15348C13.1369 2.97179 12.7655 2.81808 12.384 2.69442C12.0952 2.6008 11.8802 2.35751 11.8227 2.05938L11.5871 0.836475L10 0.833333H8.43167L8.19347 2.05577C8.1354 2.35372 7.91991 2.59654 7.63095 2.68958C7.24423 2.81412 6.86783 2.96934 6.50594 3.15347C6.2358 3.29091 5.91233 3.27084 5.66126 3.10106L4.63177 2.40491L2.41508 4.62585L3.10581 5.65142C3.27516 5.90287 3.2946 6.22646 3.15657 6.49637C2.96987 6.86144 2.81251 7.2419 2.68652 7.63298C2.59334 7.92227 2.35006 8.13787 2.05167 8.19563L0.836742 8.43075L0.833542 11.5507L2.04778 11.7882C2.34609 11.8466 2.58897 12.0627 2.68156 12.3522C2.8082 12.7482 2.96723 13.1337 3.15649 13.5037C3.29461 13.7736 3.27519 14.0972 3.10578 14.3488L2.41509 15.3742L4.63177 17.5951L5.66126 16.8989C5.91232 16.7292 6.23577 16.7091 6.50591 16.8465C6.863 17.0282 7.23458 17.1819 7.61612 17.3056C7.90493 17.3992 8.11998 17.6425 8.17742 17.9406L8.413 19.1633L11.5685 19.1665L11.8065 17.9443C11.8646 17.6463 12.0801 17.4035 12.3691 17.3104C12.7557 17.1859 13.1321 17.0307 13.4938 16.8465C13.764 16.7089 14.0877 16.729 14.3388 16.8988L15.3683 17.5952L17.5849 15.3742L16.8942 14.3486C16.7248 14.0971 16.7054 13.7733 16.8436 13.5034C17.0303 13.1385 17.1877 12.7581 17.3137 12.367C17.4068 12.0777 17.6501 11.8622 17.9485 11.8044L19.1634 11.5692L19.1665 8.44925L17.9523 8.21178ZM15.0492 18.3853L13.8719 17.5891C13.4707 17.7934 13.0533 17.9656 12.6245 18.1037L12.3481 19.5227C12.2943 19.7995 12.0438 20 11.7533 20L8.22644 19.9965C7.93556 19.9962 7.68609 19.7952 7.6327 19.518L7.35914 18.0983C6.93597 17.9611 6.52398 17.7907 6.12806 17.5892L4.95082 18.3853C4.70735 18.5499 4.37646 18.5192 4.16999 18.3121L1.67616 15.8134C1.48008 15.6169 1.45032 15.3149 1.6045 15.0859L2.41462 13.8833C2.20469 13.4729 2.0283 13.0453 1.88782 12.6061L0.485067 12.3317C0.202689 12.2765 -0.000314247 12.0358 3.65177e-07 11.7568L0.00362298 8.22312C0.00378047 7.94387 0.207413 7.70371 0.489949 7.64908L1.89333 7.37747C2.03303 6.94382 2.20753 6.52191 2.41462 6.11694L1.6045 4.91409C1.45032 4.68506 1.48008 4.38324 1.67616 4.18655L4.16999 1.68792C4.37646 1.48102 4.70719 1.44989 4.95082 1.61468L6.12806 2.41073C6.52933 2.20657 6.94668 2.03446 7.37552 1.89636L7.65208 0.477295C7.70593 0.200501 7.95556 0 8.24628 0H10L11.7736 0.00350952C12.0646 0.00381469 12.3141 0.204773 12.3674 0.482025L12.641 1.9017C13.0642 2.03888 13.476 2.20932 13.8719 2.41073L15.0493 1.61468C15.2928 1.44989 15.6238 1.48102 15.8302 1.68778L18.3238 4.18655C18.5201 4.38308 18.5498 4.68506 18.3957 4.91409L17.5855 6.11679C17.7955 6.52725 17.9717 6.95465 18.1123 7.39395L19.5149 7.66831C19.7975 7.72354 20.0003 7.96417 20 8.24326L19.9965 11.7769C19.9963 12.0561 19.7927 12.2963 19.5101 12.3509L18.1068 12.6225C17.9672 13.0562 17.7927 13.4781 17.5854 13.8831L18.3955 15.0859C18.5498 15.3149 18.5201 15.6168 18.3238 15.8134L15.8302 18.3121C15.6237 18.519 15.2928 18.5499 15.0492 18.3853Z"
                                      fill="#8392A5"></path>
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M10.0001 6.66683C8.16277 6.66683 6.66671 8.16288 6.66671 10.0002C6.66671 11.8374 8.16277 13.3335 10.0001 13.3335C11.8373 13.3335 13.3334 11.8375 13.3334 10.0002C13.3334 8.16286 11.8373 6.66683 10.0001 6.66683ZM5.83337 10.0002C5.83337 7.70263 7.70255 5.8335 10.0001 5.8335C12.2975 5.8335 14.1667 7.70263 14.1667 10.0002C14.1667 12.2977 12.2975 14.1668 10.0001 14.1668C7.70255 14.1668 5.83337 12.2977 5.83337 10.0002Z"
                                      fill="#8392A5"></path>
                            </svg>
                            {i18n.organization_settings()}
                        </Link>

                        <Link to="#" className="header__user-sublink" onClick={onLogout}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.4783 7.82608C13.7183 7.82608 13.9131 7.63129 13.9131 7.39129V2.1739C13.913 0.975652 12.9383 0 11.7391 0H2.1739C0.974796 0 0 0.975652 0 2.1739V17.8261C0 19.0243 0.974796 20 2.1739 20H11.7391C12.9383 20 13.913 19.0243 13.913 17.8261V12.6087C13.913 12.3687 13.7182 12.1739 13.4782 12.1739C13.2382 12.1739 13.0435 12.3687 13.0435 12.6087V17.8261C13.0435 18.5452 12.4583 19.1304 11.7391 19.1304H2.1739C1.45475 19.1304 0.869551 18.5452 0.869551 17.8261V2.1739C0.869551 1.45475 1.45475 0.869551 2.1739 0.869551H11.7391C12.4583 0.869551 13.0435 1.45475 13.0435 2.1739V7.39129C13.0435 7.63129 13.2383 7.82608 13.4783 7.82608Z"
                                    fill="#8392A5"></path>
                                <path
                                    d="M19.5652 9.56543H5.6522C5.4122 9.56543 5.21741 9.76023 5.21741 10.0002C5.21741 10.2402 5.4122 10.435 5.6522 10.435H19.5652C19.8052 10.435 20 10.2402 20 10.0002C20 9.76018 19.8052 9.56543 19.5652 9.56543Z"
                                    fill="#8392A5"></path>
                                <path
                                    d="M19.872 9.69388L17.2633 7.08518C17.0938 6.91562 16.8181 6.91562 16.6485 7.08518C16.479 7.25475 16.479 7.53041 16.6485 7.69998L18.9494 10.0008L16.6485 12.3017C16.479 12.4713 16.479 12.7469 16.6485 12.9165C16.7338 13.0008 16.845 13.0435 16.9564 13.0435C17.0677 13.0435 17.179 13.0009 17.2633 12.9174L19.872 10.3087C20.0416 10.1391 20.0416 9.86344 19.872 9.69388Z"
                                    fill="#8392A5"></path>
                            </svg>
                            {i18n.exit()}
                        </Link>
                    </div>
                </div>
            </div>
            {/* <ModalPublishSuccess
                modalOpen={publishModalOpen}
                setModalOpen={setPublishModalOpen}
                onDownloadQr={downloadQr}
                onDownloadMenu={downloadMenu}
            /> */}
        </header>
    )
}


function DownloadButton() {
    const {currentMenuId, user} = useUserContext()
    const {i18n, api} = useGlobalContext()
    const [isCopied, setIsCopied] = useState(false)

    const [showDownload, setShowDownload] = useState(false)

    const downloadRef = useRef(null)

    const [downloadQrLoading, setDownloadQrLoading] = useState(false)

    const [modalOpen, setModalOpen] = useState<boolean>(false)

    function downloadQr() {
        api.downloadQrCode({setLoading: setDownloadQrLoading}, currentMenuId).then((res) => {
            if (!res.error) return
            addNotification({
                type: "warning",
                message: res.error?.message || i18n.err_fetching()
            })
        })
    }

    function downloadMenu() {
        let subdomain = user?.org?.subdomain
        let menuLink = user?.org?.menus.menus?.find((v) => v.id === currentMenuId)?.link
        let url = process.env.REACT_APP_API_URL
        if (!user?.org || !subdomain || !menuLink || !url) return
        window.open(`${url.replace("api", subdomain)}/print/${menuLink}?preview=true`)
    }

    const copy2GisLink = () => {
        const url = process.env.REACT_APP_API_URL;
        const menuLink = `${url}/2gis-yml/${currentMenuId}`;

        navigator.clipboard.writeText(menuLink)
            .then(() => {
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 2000);
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    };

    useOnClickOutside(downloadRef, () => setShowDownload(false), "mouseup")
    return (
        <div className="dropdown" style={{paddingRight: "15px"}} ref={downloadRef}>
            <Link to="" className="header__qr-link" onClick={(e) => {
                e.preventDefault();
                setShowDownload(!showDownload)
            }}
                  id="qrDropdown" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                {i18n.download()}
                <i className="fa fa-caret-down"></i>
            </Link>
            <div
                className={showDownload ? "dropdown-menu dropdown-menu-left show" : "dropdown-menu dropdown-menu-left"}
                tabIndex={0}>
                <Link to="#" className="header__user-sublink"
                      onClick={(e) => {
                          e.preventDefault()
                          downloadQr()
                      }}
                >
                    {i18n.download_qr_code()}
                </Link>
                <Link to="#" className="header__user-sublink"
                      onClick={(e) => {
                          e.preventDefault()
                          downloadMenu()
                      }}
                >
                    {i18n.download_menu_for_print()}
                </Link>
                <div className="header__user-sublink"
                     onClick={() => {
                         setModalOpen(true)
                     }}
                >
                    {i18n.download_monthly_report()}
                </div>
                {
                    user?.isStaff && (
                        <div className="header__user-sublink"
                             onClick={() => {
                                 copy2GisLink();
                             }}
                        >
                            {isCopied ? i18n.copied() : i18n.copy_link_2gis()}
                        </div>
                    )
                }
                <div className="header__user-sublink"
                     onClick={() => {
                         window.open(`${process.env.REACT_APP_API_URL?.replace("api", user?.org?.subdomain || "")}/menu/${user?.org?.menus.menus?.find((v) => v.id === currentMenuId)?.link}`)
                     }}
                >
                    {i18n.view_menu()}
                </div>
            </div>
            <ModalReport modalOpen={modalOpen} setModalOpen={setModalOpen}/>
        </div>
    )
}

function ChangeMenuComponent() {
    const {user, setUser, currentMenuId, setCurrentMenuId} = useUserContext()
    const {i18n, api} = useGlobalContext()

    const [showChangeMenu, setShowChangeMenu] = useState(false)
    const changeMenuRef = useRef(null)
    useOnClickOutside(changeMenuRef, () => setShowChangeMenu(false), "mouseup")

    const [archiveLoading, setArchiveLoading] = useState(false)

    function deleteMenu(menuId: string) {
        if (user?.org) {
            api.archiveMenu({setLoading: setArchiveLoading}, menuId, user.org.id).then((res) => {
                if (res.success && res.data) {
                    if (user.org) {
                        setUser({
                            ...user,
                            org: {
                                ...user.org,
                                menus: {
                                    ...user.org.menus,
                                    defaultId: res.data.defaultId,
                                    menus: (user.org?.menus.menus || []).filter((m) => m.id !== menuId),
                                    all: (user.org?.menus.all || []).filter((m) => m.menuId !== menuId)
                                }
                            }
                        })
                    }
                    setCurrentMenuId(res.data.defaultId)
                }
            })
        }
    }

    return (
        <div className="dropdown" style={{paddingRight: "15px"}} ref={changeMenuRef}>
            <Link to="" className="header__qr-link" onClick={(e) => {
                e.preventDefault();
                setShowChangeMenu(!showChangeMenu)
            }
            } data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                {user?.org?.menus.menus?.find((m) => m.id === currentMenuId)?.name}
                <i className="fa fa-caret-down"></i>
            </Link>
            <div
                className={showChangeMenu ? "dropdown-menu dropdown-menu-left show" : "dropdown-menu dropdown-menu-left"}
                tabIndex={0}>
                <div style={{maxHeight: "150px", overflowY: "auto"}}>
                    {user?.org?.menus.menus?.map((menu) => {
                        return (
                            <div style={{display: "flex"}} key={"header-org-" + menu.id}>
                                <Link
                                    style={{width: (user.org?.menus.all || []).length > 1 ? "80%" : "100%"}}
                                    key={"header-menu-" + menu.id} to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowChangeMenu(false);
                                        setCurrentMenuId(menu.id);
                                    }}
                                    className={menu.id === currentMenuId ? "header__user-sublink -blue" : "header__user-sublink"}>
                                    {menu.name}
                                </Link>
                                {(user.org?.menus.all || []).length > 1 ?
                                    <button style={{border: 0, width: "20%"}}
                                            className={menu.id === currentMenuId ? "header__user-sublink -blue -n20" : "header__user-sublink -n20"}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowChangeMenu(false);
                                                addNotificationWithButton({
                                                    message: `${i18n.q_delete_menu()} ${menu.name}`,
                                                    onSubmit: () => deleteMenu(menu.id),
                                                    loading: archiveLoading,
                                                    i18n,
                                                })
                                            }}>x
                                    </button>
                                    :
                                    null}
                            </div>
                        )
                    })}
                </div>
                <hr style={{margin: 0}}/>
                <Link to="menu/create" className="header__user-sublink"
                      onClick={() => setShowChangeMenu(false)}>
                    {i18n.add_menu()}
                </Link>

            </div>
        </div>
    )
}

function ChangeOrgComponent() {
    const navigate = useNavigate();
    const {user} = useUserContext()
    const {i18n} = useGlobalContext()
    const {changeOrg, orgNames, removeOrg, onStaffPage} = useStaffContext()

    const [showChangeOrg, setShowChangeOrg] = useState(false)

    const changeOrgRef = useRef(null)

    useOnClickOutside(changeOrgRef, () => setShowChangeOrg(false), "mouseup")
    return (
        <div className="dropdown" ref={changeOrgRef}>
            <Link to="" className="header__qr-link" onClick={(e) => {
                e.preventDefault();
                setShowChangeOrg(!showChangeOrg)
            }
            } id="qrDropdown" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                {user?.org ?
                    user.org.name
                    : i18n.select_org()
                }
                <i className="fa fa-caret-down"></i>
            </Link>
            <div
                className={showChangeOrg ? "dropdown-menu dropdown-menu-left show" : "dropdown-menu dropdown-menu-left"}
                tabIndex={0}>
                {orgNames.map((org) => {
                    return (
                        <div style={{display: "flex"}} key={"header-org-" + org.id}>
                            <Link to="#" onClick={(e) => {
                                e.preventDefault();
                                setShowChangeOrg(false);
                                changeOrg(org.id);
                                localStorage.setItem("lastOrg", org.id);
                                navigate(RouteNames.SLIDER)
                            }}
                                  className={org.id === user?.org?.id ? "header__user-sublink -blue -n80" : "header__user-sublink -n80"}>
                                {org.name}
                            </Link>
                            <button style={{border: 0}}
                                    className={org.id === user?.org?.id ? "header__user-sublink -blue -n20" : "header__user-sublink -n20"}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowChangeOrg(false);
                                        removeOrg(org.id)
                                    }}>x
                            </button>
                        </div>
                    )
                })}
                <hr style={{margin: 0}}/>
                <Link to="#" className="header__user-sublink"
                      onClick={(e) => {
                          e.preventDefault();
                          onStaffPage();
                          navigate(RouteNames.STAFF_CLIENTS)
                      }}
                >
                    {i18n.to_admin_page()}
                </Link>

            </div>
        </div>
    )
}
